export const sendAnalyticsContent = (thdAnalyticsContent, timeOut = 1000) => new Promise((resolve) => {
  if (!window.digitalData.content) {
    window.digitalData.content = {};
    window.digitalData.content.module = [];
  }
  window.digitalData.content.module.push(thdAnalyticsContent);
  window.setTimeout(resolve(), timeOut);
});